/**
 * internal dependencies
 */
import { WpAuthorizeUser } from "../routes/wp-login-user";
import CognitoLoginUser from "../auth/cognito-login-user";
import { IUser } from '../models/user.interface';
import { ILoginUser } from '../models/login.interface';
import { awsApiInstance } from "../api/aws-api";
import { configureStore } from '../store/store';
import { signIn } from '../store/actions/index';
import { cognitoError } from '../types/types';

/**
 * Handles signing the to the site.
 * 
 * @returns void
 */
const AuthorizeSignIn = async () => {
  const submitForm = document.querySelector('#aafp_login_submit') as HTMLInputElement;
  if ( !submitForm ) return;

  submitForm.addEventListener('click', async (event) => {
    if ( submitForm.checkValidity() ) {
      event.preventDefault();
      submitForm.classList.remove('was-validated');
      submitForm.classList.remove('form-control:valid');
      submitForm.classList.add('aafp_button-loading');
    
      const user = (document.querySelector('#user_login') as HTMLInputElement).value.trim();
      const pass = (document.querySelector('#user_pass') as HTMLInputElement).value.trim();

      try {
        const loginModel = {
          user: user,
          pass: pass
        };

        const awsResponse = await CognitoLoginUser(loginModel);

        if ( awsResponse.hasOwnProperty('errorType') ) {
          cognitoError.innerHTML += `<p>${awsResponse.body.message}</p>`;
          submitForm.classList.remove('aafp_button-loading');
          return;
        }

        if ( awsResponse ) {
          const wpResponse = await WpAuthorizeUser(loginModel);

          const { userId, route } = wpResponse.body;
          const response = await awsApiInstance.get<IUser>(`/user/${userId}`);
          const { statusCode, body } = response.data;

          if (statusCode === 400) {
            console.error('Error logging in user #%s', userId);
            throw new Error('Error logging in user');
          }

          let awsUser = {};
          if (body.accessList.length === 0) {
            awsUser = {'accessLevel': 'A', 'accessType': 'E', 'accessList': [{'id': '0', 'name': ''}]};
          } else {
            awsUser = {...body};
          }

          const theUser = { ...awsUser, ...wpResponse.body } as ILoginUser;

          const action = signIn(theUser);
          configureStore.dispatch(action);

          location.href = `/${route}/`;
        } else {
          console.error('Error logging in user #%s', user);
          throw new Error('Error logging in user');
        }   
      } catch (error: any) {
        console.error('errors', error);
        cognitoError.innerHTML += `<p>${error.message}</p>`;
        submitForm.classList.remove('aafp_button-loading');
      }
    } else {
      event.preventDefault();
      event.stopPropagation();
      submitForm.classList.add('was-validated');
      submitForm.classList.remove('aafp_button-loading');
    } 
  });
};

export default AuthorizeSignIn;